import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/chat',
    name: 'ChatMain',
    component: () => import('../views/ChatMain.vue')
  },
  {
    path: '/friend',
    name: 'FriendMain',
    component: () => import('../views/FriendMain.vue')
  },
  {
    path: '/group',
    name: 'GroupMain',
    component: () => import('../views/GroupMain.vue')
  },
  {
    path: '/mall',
    name: 'MallMain',
    component: () => import('../views/MallMain.vue')
  },
]

const router = new VueRouter({
  // 将默认的 hash 模式改为 history 模式，从而彻底去掉路径中的 # 号
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
